<div
  #newGroupButton
  data-test="addGroupOrSortButton"
  class="addNewGroupButton"
  (click)="action($event)"
  [class.addNewGroupButton--disabled]="ppDisabled"
>
  <pp-icon ppClass="setSize14" [ppSrc]="EIconPath.ICON_PLUS"></pp-icon>
  <span class="addNewGroupButton__text">{{ ppText }}</span>
</div>
